import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { Draggable } from "gsap/Draggable";
import { usePathname } from "next/navigation";
import { useGSAP } from "@gsap/react";

// Register plugins only once
gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin, Draggable);

export const useSmoothScroll = (isMobile, smoothWrapperRef) => {
    const el = useRef();
    const pathname = usePathname();


    useGSAP(() => {
        // Declare smoother instance
        let smoother;
        const circle = document.querySelector('.circle_circle');
        // Detect macOS/iOS devices
        const isMacOrIOS = typeof navigator !== "undefined" && /Mac|iPhone|iPad|iPod/i.test(navigator.platform);

        // Only initialize smoother for non-touch devices and if window is available
        if (typeof window !== "undefined" && !ScrollTrigger.isTouch) {
            smoother = ScrollSmoother.create({
                smooth: !isMobile ? 2 : 2, // Smoothness level based on device type
                effects: !isMobile,
                smoothTouch: 0.1,
                ignoreMobileResize: true,
            });
        }



        // Refresh ScrollTrigger on initialization
        ScrollTrigger.refresh();

        // Scroll to top when the page changes

        // Cleanup function to prevent memory leaks
        return () => {
            if (smoother) {
                smoother.kill();  // Properly kill the smoother instance
            }
            ScrollTrigger.clearMatchMedia(); // Clears any responsive scroll configurations
            ScrollTrigger.getAll().forEach(trigger => trigger.kill()); // Remove any existing ScrollTriggers
        };
    }, [isMobile, pathname]);

    return el;
};
